<template>
  <div>
    <div v-if="showReason(coursePriceData)" class="refund-nopass-reason">
      <div class="nopass-title">审核不通过原因</div>
      <div class="nopass-content">
        {{ coursePriceData.refuse_reason }}
      </div>
    </div>
    <div class="apply-class-box">
      <div class="apply-class-h">
        <div v-if="coursePriceData.goods_info" class="apply-class-title">
          {{ coursePriceData.goods_info.production_name }}
        </div>
        <div class="apply-class-time">
          购买时间：{{ coursePriceData.goods_info.payment_time }}
        </div>
      </div>

      <div class="split-line"></div>

      <div
        v-if="showCourseList && showCourseList.length"
        class="apply-class-detail"
      >
        <div
          v-for="singleClass in showCourseList"
          :key="singleClass.production_id"
          class="each-class-detail"
        >
          <div class="detail-name-price">
            <span>
              {{ singleClass.app_name }}：{{ showText(singleClass) }}
            </span>
            <div>
              <div>{{ singleClassText(singleClass) }}</div>
              <div
                v-if="showSingleMoney(singleClass)"
                class="detail-save-price"
              >
                ¥{{ transformMoney(singleClass.production_price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-price-compute">
      <div class="price-pay-in">
        <span class="price-text-style">课程实付价格：</span>
        <span class="price-price-style"
          >¥{{ transformMoney(coursePriceData.pay_amount) }}</span
        >
      </div>
      <div
        v-for="type in coursePriceData.only_refund_info"
        :key="type.key"
        class="price-discount"
      >
        <span class="price-text-style">{{ DiscountMethods[type.key] }}：</span>
        <span class="price-price-style"
          >-¥{{ transformMoney(type.amount) }}</span
        >
      </div>
      <div
        v-for="(studyedClass, index) in coursePriceData.app_amount"
        :key="studyedClass.app_name + index"
        class="price-studyed-amount"
      >
        <div class="price-studyed">
          <span class="price-text-style"
            >{{ studyedClass.app_name }}已学关卡：</span
          >
          <span class="price-price-style"
            >-¥{{ transformMoney(studyedClass.amount) }}</span
          >
        </div>
        <div class="price-studyed-formula">={{ studyedClass.formula }}</div>
      </div>
      <div
        v-if="
          typeof coursePriceData.subsidy_refund_amount === 'number' &&
            coursePriceData.subsidy_refund_amount !== 0
        "
        class="price-subsidy-difference"
      >
        <span class="price-text-style">补贴退款：</span>
        <span class="price-price-style"
          >-¥{{ transformMoney(coursePriceData.subsidy_refund_amount) }}</span
        >
      </div>

      <div class="split-line"></div>

      <div class="refund">
        <span class="refund-text">退款金额：</span>
        <span class="refund-price"
          ><span class="refund-price-icon">¥</span
          >{{ transformMoney(coursePriceData.refund_amount) }}</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Vue, Component, Mixins } from 'vue-property-decorator';
import Refund from '../mixin/refund';
import {
  DiscountMethods,
  CourseType,
  isGiveEnum,
  isSingleEnum,
  studyedEnum,
  detailTextStatus,
  refundDetailStatus,
} from '../refundEnum';
@Component({})
export default class PriceList extends Mixins(Refund) {
  @Prop({ type: Object, default: () => {} })
  coursePriceData!: any;
  DiscountMethods: any = DiscountMethods;
  CourseType: any = CourseType;

  get courseType() {
    return this.coursePriceData.goods_info.production_type;
  }

  get showCourseList() {
    if (this.courseType === CourseType.singleCourse) {
      return this.coursePriceData.goods_info
        ? [this.coursePriceData.goods_info]
        : [];
    }
    return this.coursePriceData?.goods_info?.app_info || [];
  }

  get showReason() {
    return ({ status }: any) => {
      return status === refundDetailStatus.checkNopass;
    };
  }

  get showText() {
    return (singleClass: any) => {
      return singleClass.progress.studyed !== studyedEnum.isStudyed
        ? '未学习'
        : `第${singleClass.progress.finish_num}关 (${singleClass.progress.finish_num}/${singleClass.progress.total_num})`;
    };
  }

  get showSingleMoney() {
    return (singleClass: any) => {
      return singleClass.is_give !== isGiveEnum.isGive && !singleClass.status;
    };
  }

  get singleClassText() {
    return (singleClass: any) => {
      if (singleClass.status) {
        return detailTextStatus[singleClass.status];
      }
      return singleClass.is_give === isGiveEnum.isGive
        ? '赠品'
        : `实付 ¥${this.transformMoney(singleClass.amount)}`;
    };
  }
}
</script>

<style lang="scss" scoped>
@import '../style/base.scss';
.apply-class-box,
.apply-price-compute,
.refund-nopass-reason {
  @include border_radius(24px);
  width: 702px;
  padding: 32px;
  background-color: $whiteColor;
}
.nopass-title {
  @include line_height(45px);
  @include font_color(32px, Sem, 600, $deepPurpleColor);
  @include margin_bottom(28px);
}
.nopass-content {
  @include font_color(28px, Reg, 400, $baseTheme);
  line-height: 50px;
}

.apply-class-box,
.apply-price-compute,
.refund-nopass-reason {
  @include margin_bottom(24px);
}

.split-line {
  @include hei_wid(1px, 640px);
  margin: 34px 0;
  background: $deepPurpleColor;
  opacity: 0.1;
}

.apply-class-h .apply-class-title {
  @include line_height(45px);
  @include font_color(32px, Sem, 600, $deepPurpleColor);
  margin-bottom: 8px;
}

.apply-class-h .apply-class-time {
  @include line_height(33px);
  @include font_color(24px, PFRSC, 400, $baseTheme);
  opacity: 0.4;
}

.apply-class-detail .each-class-detail {
  @include margin_bottom(16px);
}

.apply-class-detail .each-class-detail:last-of-type {
  @include margin_bottom(0);
}

.detail-name-price {
  @include flex_center(space-between, none);
}

.detail-name-price > span {
  @include font_color(28px, PFRSC, 400, $deepPurpleColor);
  margin-right: 16px;
  line-height: 40px;
}

.detail-name-price > div {
  flex-shrink: 0;
  line-height: 40px;
  @include font_color(28px, alt, 400, $deepPurpleColor);
}
.detail-save-price,
.price-studyed-formula {
  @include line_height(33px);
  @include font_color(24px, alt, 400, rgba(49, 40, 93, 0.4));
  text-align: right;
}

.price-pay-in,
.price-discount,
.price-studyed,
.price-subsidy-difference,
.refund {
  @include flex_center(space-between, none);
}

.price-text-style {
  @include font_color(28px, Reg, 400, #31285d);
  margin-right: 16px;
  opacity: 0.6;
}

.price-price-style {
  @include font_color(28px, alt, 400, $deepPurpleColor);
  flex-shrink: 0;
}

.price-pay-in,
.price-discount,
.price-studyed-amount,
.price-subsidy-difference {
  @include margin_bottom(16px);
}

.refund-text {
  @include font_color(32px, Sem, 600, $deepPurpleColor);
}

.refund-price {
  @include font_color(28px, alt, bold, $redColor);
}
.refund-price-icon {
  display: inline-block;
  font-size: 32px;
  vertical-align: middle;
  transform: scale(0.5);
}
</style>
